export default __webpack_public_path__ + "static/media/Pastry.a82914dd.png";